import React, { createContext, useContext, useMemo, useState } from "react";
import { wrapperMap } from "./controlWrappers";
import "../../assets/css/revised_css/components/controlManagerThemes/controlManager.css"
import { Col, Container, Row } from "react-bootstrap";
import useScrollPercentage from "../scripts/useScrollPercentage";
import { useControl } from "./controlContext";


export const ControlWrapperContext = createContext(null)

export function ControlWrapperProvider({ children, options = {}, objectMetadata, onSubmit,  }) {
  const [settings, setSettings] = useState({})
  const scrollState = useScrollPercentage()
  const controls = useControl()
  let [per] = useMemo(() => [scrollState[1], scrollState[2]], [scrollState]) //just ignore the stupidity
  const controlIds = useMemo(() => controls.map(itm => itm._id).join(',') + `,${per}`, [controls, per])

  const topBlock = useMemo(() => {
      // console.log('per', per)
      let idArray = controlIds.split(',').slice(0, controlIds.split(',').length - 1)
  
      for (let i = 0; i < idArray.length; i++) {
        // const block = controls.find()
        let [isVisible] = isElementInViewPort(document.getElementById(idArray[i]))
        if (isVisible) {
          return idArray[i] 
        }
      }
      return idArray[0]
    }, [controlIds])

  const [childContainerRef] = scrollState

  const { HeaderWrapper, BodyWrapper, ContainerWrapper} = useMemo(() => {
    const modules = options.modules || {}
    return {
      HeaderWrapper: modules.header || EmptyWrap,
      BodyWrapper: modules.body || EmptyWrap,
      ContainerWrapper: modules.container || EmptyWrap
    }
  }, [options, objectMetadata])
  const [controlHeader, setControlHeader] = useState([])
  const bodyColWidth = useMemo(() => ({ 
    wrapper:  options.modules && options.modules.body ? 3 : 0, 
    body:  options.modules && options.modules.body ? 9 : 12 }), [BodyWrapper])

  return (
    <ControlWrapperContext.Provider value={{ setControlHeader, settings, setSettings, topBlock }}>
      <ContainerWrapper options={options} objectMetadata={objectMetadata} onSubmit={onSubmit} topBlock={topBlock}>
        <HeaderWrapper childContainerRef={childContainerRef} objectMetadata={objectMetadata} topBlock={topBlock} settings={settings} setSettings={setSettings} >{controlHeader}</HeaderWrapper>
        <Row className="con-man-wrapper g-0">
          <Col sm={bodyColWidth.wrapper} className="con-man-wrapper">
            {BodyWrapper ? (
              <BodyWrapper objectMetadata={objectMetadata} controlIds={controlIds} topBlock={topBlock} scrollState={scrollState} settings={settings} setSettings={setSettings}/>
            ) : []}
          </Col>
          <Col sm={bodyColWidth.body} className="con-man-wrapper">
            <Container ref={childContainerRef} className="control-manager-child-container">
              {children}
            </Container>
          </Col>
        </Row>
      </ContainerWrapper>

    </ControlWrapperContext.Provider>
  )
}

function EmptyWrap({ children }) {
  return children || null
}


export function useControlHeaderContext() { return useContext(ControlWrapperContext) }



// percent X,Y are amount to return true if greater than
function isElementInViewPort(element, percentX, percentY) {
  if (!element) return [false]
  var tolerance = 0.01;   //needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
  if (percentX == null) {
    percentX = 40;
  }
  if (percentY == null) {
    percentY = 40;
  }

  var elementRect = element.parentElement.parentElement.getBoundingClientRect();
  var parentRect
  // var element = this;
  // console.log('start loop')
  parentRect = element.parentElement.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect();
  // while (!element.className.includes('control-manager-child-container')) {
  //   element = element.parentElement;
  //   console.log('looping looking')
  // }
  // console.log('topmost parent?', parentRect, element, element.className)
  // var visibleInAllParents = parentRects.every(function(parentRect){
  // var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
  var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);


  // var visiblePercentageX = visiblePixelX / parentRect.width * 100;
  var visiblePercentageY = visiblePixelY / parentRect.height * 100;
  // console.log('got these results', visiblePercentageY, visiblePixelY)
  return [visiblePercentageY + tolerance > percentY, visiblePercentageY];
  // });
  // return visibleInAllParents;
}